(function () {
  'use strict';

  /* Guard against the script being evaluated twice (theme editor section reloads). */
  if (window.__cbCaseStudyLoaded) return;
  window.__cbCaseStudyLoaded = true;

  var teardown = null;

  function init(root) {
    if (!root || root.dataset.cbReady) return;
    root.dataset.cbReady = 'true';

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var items = Array.prototype.slice.call(root.querySelectorAll('.cb-reveal'));
    var layers = Array.prototype.slice.call(root.querySelectorAll('[data-cb-depth]'));
    var videos = Array.prototype.slice.call(root.querySelectorAll('video'));
    var io = null;
    var ticking = false;
    var MAX_SHIFT = 24;

    function showAll() {
      items.forEach(function (el) { el.classList.add('cb-is-visible'); });
    }

    /* Scroll reveals. The hidden state only exists once .cb-js is set, so content stays visible if this script never runs.
       Everything is shown immediately when motion is reduced or IntersectionObserver is missing. */
    function startReveals() {
      if (io || !('IntersectionObserver' in window)) return;
      io = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          /* Reveal anything intersecting or already scrolled past (e.g. reload mid-page). */
          if (!entry.isIntersecting && entry.boundingClientRect.top > 0) return;
          entry.target.classList.add('cb-is-visible');
          obs.unobserve(entry.target);
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
      items.forEach(function (el) { if (!el.classList.contains('cb-is-visible')) io.observe(el); });
    }

    /* Gentle depth: small, clamped translateY driven by scroll. No pointer or hover dependency. */
    function update() {
      ticking = false;
      var vh = window.innerHeight || 1;
      layers.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < -200 || rect.top > vh + 200) return;
        var factor = parseFloat(el.getAttribute('data-cb-depth')) || 0;
        var offset = (rect.top + rect.height / 2 - vh / 2) * factor;
        var shift = Math.max(-MAX_SHIFT, Math.min(MAX_SHIFT, offset));
        el.style.setProperty('--cb-shift', shift.toFixed(1) + 'px');
      });
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }
    function bindDepth() {
      if (!layers.length) return;
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      update();
    }
    function unbindDepth() {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      layers.forEach(function (el) { el.style.removeProperty('--cb-shift'); });
    }

    function applyMotionPreference() {
      if (reduced.matches) {
        if (io) { io.disconnect(); io = null; }
        unbindDepth();
        showAll();
      } else {
        startReveals();
        unbindDepth();
        bindDepth();
      }
    }

    root.classList.add('cb-js');
    if (!('IntersectionObserver' in window)) showAll();
    applyMotionPreference();

    if (reduced.addEventListener) reduced.addEventListener('change', applyMotionPreference);
    else if (reduced.addListener) reduced.addListener(applyMotionPreference);

    /* Videos never autoplay; only one plays at a time. */
    var onPlay = function (event) {
      videos.forEach(function (other) { if (other !== event.target && !other.paused) other.pause(); });
    };
    videos.forEach(function (video) { video.addEventListener('play', onPlay); });

    teardown = function () {
      if (io) io.disconnect();
      unbindDepth();
      if (reduced.removeEventListener) reduced.removeEventListener('change', applyMotionPreference);
      else if (reduced.removeListener) reduced.removeListener(applyMotionPreference);
      videos.forEach(function (video) { video.removeEventListener('play', onPlay); video.pause(); });
      teardown = null;
    };
  }

  function ours(event) {
    var t = event && event.target;
    return !t || !t.querySelector || t.id === 'coffee-bond-case-study' || !!t.querySelector('#coffee-bond-case-study');
  }
  function scan(event) {
    if (!ours(event)) return;
    if (teardown) teardown();
    init(document.getElementById('coffee-bond-case-study'));
  }
  function release(event) {
    if (ours(event) && teardown) teardown();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', release);
})();
